import React from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import ErrorMessage from '../../../ErrorMessage';
import OfficeService from '../../../../Services/OfficeService';

export default class OfficeSelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    filterCleared: false,
    fieldName: 'defaultFieldname',
    onChange: () => {},
    changeOfEditedMultipItem: () => {},
    IsCheckBoxEnabled: false,
    editedItem: {},
    idFilter: null,
    showSelectFilterAt: 10,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  populateListData() {
    OfficeService.GetOfficesForSelect()
      .then((result) => {
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result.forEach((office) => {
          optValues.push({
            label: office.name,
            value: office.officeId,
            disabled: false,
          });
        });
        this.setState({ selectValues: optValues });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('OS39');
      });
  }

  getFilteredValues() {
    const { idFilter } = this.props;
    if (!idFilter) return this.state.selectValues;
    if (Array.isArray(idFilter)) {
      return this.state.selectValues.filter((opt) => opt.value === '' || !idFilter.includes(opt.value));
    }
    return this.state.selectValues.filter((opt) => opt.value === '' || opt.value !== idFilter);
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        filterCleared={this.props.filterCleared}
        IsCheckBoxEnabled={this.props.IsCheckBoxEnabled}
        changeOfEditedMultipItem={this.props.changeOfEditedMultipItem}
        selectValues={this.getFilteredValues()}
        editedItem={this.props.editedItem}
        showSelectFilterAt={this.props.showSelectFilterAt}
      />
    );
  }
}
